import { Component } from '@angular/core';

@Component({
    selector: 'on-target-section',
    standalone: true,
    templateUrl: './on-target-section.component.html',
    styleUrl: './on-target-section.component.less',
})
export class OnTargetComponent {}
